import styled from 'foundations-theming/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledText = styled.div.withConfig({
  displayName: "Title__StyledText",
  componentId: "b4fci3-0"
})(({
  theme
}) => {
  return {
    fontSize: theme.typography['heading-1000'].fontSize,
    lineHeight: theme.typography['heading-1000'].lineHeight,
    fontWeight: 200,
    marginTop: theme.space['200']
  };
});
export const Title = props => {
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledText, {
      children: /*#__PURE__*/_jsx(FormattedMessage, Object.assign({}, props))
    })
  );
};